import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Market from "@/view/market";
import myOrder from "@/view/myOrder";
import Market_h5 from "@/view/market_h5";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/market",
      meta: {
        title: "权益超市"
      }
    },
    {
      path: "/market",
      name: "Market",
      component: Market,
      meta: {
        title: "权益超市"
      }
    },
    {
      path: "/market_h5",
      name: "Market_h5",
      component: Market_h5,
      meta: {
        title: "权益超市"
      }
    },
    {
      path: "/myOrder",
      name: "myOrder",
      component: myOrder,
      meta: {
        title: "我的订单"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js